export type RedirectRoute = {
  helper: string
  params?: Record<string, unknown>
  param_mapping?: Record<string, unknown>
}

export type ToolbarContext = {
  project_id: string | number
  show?: boolean
  active_app?: string | number
  include_survey_portal_check?: boolean
  redirect_route?: RedirectRoute
}

export function readToolbarContext(): ToolbarContext | null {
  const el = document.getElementById('toolbar-context')
  if (!el) return null

  const value = el.dataset.value
  if (!value) return null

  try { return JSON.parse(value) } catch { return null }
}

export function writeToolbarContext(value: ToolbarContext): void {
  const el = document.getElementById('toolbar-context') as HTMLInputElement | null
  if (!el) return
  el.dataset.value = JSON.stringify(value)
}

export function bumpToolbarRevision(): void {
  document.getElementById('toolbar-context')?.setAttribute('data-revision', String(Date.now()))
}
